import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { apiCall } from '../utils/api';
import useUserPermissions from '../hooks/useUserPermissions';
// import { fetchAuthSession } from 'aws-amplify/auth';

function ModuleList() {
  const navigate = useNavigate();
  const { canModify } = useUserPermissions();
  const [modules, setModules] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedModuleId, setSelectedModuleId] = useState(null);
  const rowsPerPage = 10;

  useEffect(() => {
    fetchModules();
  }, []);

  const fetchModules = async () => {
    try {
      // const session = await fetchAuthSession();
      // const idToken = session.tokens?.idToken?.toString();
      // if (!idToken) throw new Error("User not authenticated");

      // console.log("ID token", idToken);

      setLoading(true);
      const data = await apiCall('/modules');
      // const response = await fetch('/api/modules', {
      //   headers: {
      //     Authorization: `Bearer ${idToken}`
      //   } 
      // });
      // if (!response.ok) {
      //   throw new Error(`HTTP error! status: ${response.status}`);
      // }
      // const data = await response.json();
      setModules(data);
    } catch (error) {
      console.error("Could not fetch modules:", error);
      setError("Failed to load modules. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  const handleCheckboxChange = (moduleId) => {
    setSelectedModuleId((prevSelected) => (prevSelected === moduleId ? null : moduleId));
  };

  const handleDeleteModule = async () => {
    if (!selectedModuleId || !window.confirm(`Are you sure you want to delete module ${selectedModuleId}?`)) {
      return;
    }
    try {
      await apiCall(`/modules/${selectedModuleId}`, {
        method: 'DELETE',
      });
      alert('Module deleted successfully!');
      setSelectedModuleId(null); // Clear selection
      fetchModules(); // Refresh the list
    } catch (err) {
      console.error(err);
      alert(err.message || 'Failed to delete module.');
    }
  };
  
  // ... (navigation and pagination handlers remain the same)
  const handleCreateModule = () => navigate('/create-module');
  const handleEditModule = () => { if (selectedModuleId) navigate(`/edit-module/${selectedModuleId}`); };
  const handleClose = () => navigate('/'); // Navigate to home or another appropriate page
  const handlePrevPage = () => { if (currentPage > 1) setCurrentPage(currentPage - 1); };
  const handleNextPage = () => { if (currentPage < totalPages) setCurrentPage(currentPage + 1); };

  const totalPages = Math.ceil(modules.length / rowsPerPage);
  const startIndex = (currentPage - 1) * rowsPerPage;
  const currentModules = modules.slice(startIndex, startIndex + rowsPerPage);

  if (loading) return <div>Loading modules...</div>;
  if (error) return <div className="alert alert-danger">{error}</div>;

  return (
    <div className="container mt-4">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <div>
          <h2>Modules</h2>
          {/* {isReadOnly() && (
            <small className="text-muted">Viewing as: {getUserRole()} (Read-only access)</small>
          )} */}
        </div>
      </div>
      
      {/* Table JSX remains largely the same */}
      <table className="table table-bordered">
        <thead className="table-dark">
          <tr>
            {canModify() && <th></th>}
            <th>Module ID</th>
            <th>Module Description</th>
            <th>Modified Date</th>
            <th>Modified By</th>
          </tr>
        </thead>
        <tbody>
          {currentModules.map((moduleItem) => (
            <tr key={moduleItem['Module ID']}>
              {canModify() && (
                <td>
                  <input
                    type="checkbox"
                    checked={selectedModuleId === moduleItem['Module ID']}
                    onChange={() => handleCheckboxChange(moduleItem['Module ID'])}
                  />
                </td>
              )}
              <td>
                <a href={`/view-module/${moduleItem['Module ID']}`} onClick={(e) => { e.preventDefault(); navigate(`/view-module/${moduleItem['Module ID']}`); }}>
                  {moduleItem['Module ID']}
                </a>
              </td>
              <td>{moduleItem['Module Description']}</td>
              <td>{moduleItem['ModifiedDate']}</td>
              <td>{moduleItem['ModifiedBy']}</td>
            </tr>
          ))}
        </tbody>
      </table>
      
      {/* Pagination JSX remains the same */}
       <div className="d-flex justify-content-center align-items-center mt-4">
            <button onClick={handlePrevPage} disabled={currentPage === 1}>Previous</button>
            <span className="mx-2">Page {currentPage} of {totalPages}</span>
            <button onClick={handleNextPage} disabled={currentPage === totalPages}>Next</button>
        </div>

      <div className="button-group d-flex justify-content-end mt-3">
        {canModify() && (
          <>
            <button onClick={handleCreateModule} className="btn btn-success me-2">📝 Create Module</button>
            <button onClick={handleEditModule} className="btn btn-warning me-2" disabled={!selectedModuleId}>✏️ Edit</button>
            <button onClick={handleDeleteModule} className="btn btn-danger me-2" disabled={!selectedModuleId}>🗑️ Delete</button>
          </>
        )}
        <button onClick={handleClose} className="btn btn-secondary">❌ Close</button>
      </div>
    </div>
  );
}

export default ModuleList;
